import { CSSProperties } from 'react'
import { Button, Column, Heading } from '@skedulo/breeze-ui-react'
import { ReactComponent as RoadblockErrorSVG } from '../images/roadblock-error.svg'

export const TooManyErrorsFallback = () => {
  const handleReload = () => window.location.reload()

  return (
    <Column
      align="center"
      style={
        {
          '--top-offset':
            'var(--navbar-height, calc(var(--brz-spacing-12) + var(--brz-spacing-1)))',
          backgroundColor: 'var(--brz-color-white)',
          position: 'fixed',
          top: 'var(--top-offset)',
          left: 0,
          height: 'calc(100vh - var(--top-offset))',
          width: '100%',
          paddingTop: '10rem',
          textAlign: 'center',
          zIndex: 'var(--brz-z-index-dialog)',
        } as CSSProperties
      }
    >
      <Column
        align="center"
        style={{ maxWidth: '480px', gap: 'var(--brz-spacing-5)' }}
      >
        <RoadblockErrorSVG />

        <Heading size="2xl">Something went wrong</Heading>

        <div
          style={{
            fontSize: 'var(--brz-font-size-lg)',
            lineHeight: 'var(--brz-line-height-lg)',
            color: 'var(--brz-color-neutral-700)',
          }}
        >
          Multiple components on this page failed to load. Please try reloading
          the page.
        </div>

        <Button onClick={handleReload}>Reload page</Button>
      </Column>
    </Column>
  )
}
